import React from 'react';
import { IconProps } from './types';

const Close: React.FC<IconProps> = ({
  className,
  color = '#181B32',
  size = 32,
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={1 * size}
    height={size}
    viewBox="0 0 32 32"
  >
    <title />
    <path
      fill={!ignoreColor ? color : undefined}
      d="M31.9 6l-5.95-6-10 10-9.95-10-6 6 10 10-10 10 6 6 9.95-10 10 10 5.95-6-9.95-10z"
    />
  </svg>
);

export default Close;
